import { render, staticRenderFns } from "./CreateBuildingModal.vue?vue&type=template&id=86b0a37a&"
import script from "./CreateBuildingModal.vue?vue&type=script&lang=js&"
export * from "./CreateBuildingModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateBuildingModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports